import React from "react";
import { Doughnut } from "react-chartjs-2";
import ModalIndex from "@Modals/layout/index";
import Legende from "./Legende";

export default React.memo(function GraphModal({
  onclickClose,
  title,
  legends,
  graphData,
  graphOptions,
  show,
  showCount,
  chartRef
}) {
  return (
    <ModalIndex  
      isOpen={show}
      onClickClose={onclickClose}
      title={title}
      widthType="extra-large"
      buttonType="none"
    >
      <div className="arh-w-full arh-flex ">
        <div className="arh-flex arh-flex-wrap arh-justify-start arh-mt-5 arh-flex-col">
          {legends?.length
            ? legends.map((legend) => (
                <Legende
                  key={legend?._id || legend?.name}
                  name={`${legend?.name || ""} ${
                    showCount ? `(${legend?.count || 0})` : ""
                  }`}
                  backgroundColor={legend?.backgroundColor}
                  className="arh-w-full"
                  classParagraph="arh-font-semibold"
                />
              ))
            : ""}
        </div>
        <div className="arh-flex-1 arh-flex arh-justify-between arh-items-start arh-mt-12">
          <Doughnut ref={show ? chartRef: null} data={graphData} options={graphOptions} />
        </div>
      </div>
    </ModalIndex  >
  );
});
